<template>
  <div class="page">
    <div ref="container" class="container"></div>
    <div v-if="ruleId !== ''" :style="'height:'+canvasHeight+'px'" class="right-form">
      <KeywordsFormRule :rule-id="ruleId"></KeywordsFormRule>
    </div>
  </div>
</template>

<script>
import LogicFlow from "@logicflow/core";
import {Control, MiniMap} from "@logicflow/extension";
import "@logicflow/core/lib/style/index.css";
import "@logicflow/extension/lib/style/index.css"
import NodeStart from "@/views/applications/frameTest/process/NodeStart";
import NodeNormal from "@/views/applications/frameTest/process/NodeNormal";
import NodeJudge from "@/views/applications/frameTest/process/NodeJudge";
import NodeEnd from "@/views/applications/frameTest/process/NodeEnd";
import PrcPolyline from "@/views/applications/frameTest/process/PrcPolyline";
import KeywordsFormRule from "@/views/applications/crm/pushRule/KeywordsFormRule.vue";

export default {
  name: "CrmCompanyRule",
  components: {KeywordsFormRule},
  emits: ['node-click'],
  data() {
    return {
      ruleId: '',
      canvasWidth:100,
      canvasHeight:100,
      content:{
        "nodes":[
          {
            "code":"create",
            "x":350,
            "y":50,
            "name":"企业机会推送",
            "id":"create",
            "text":{
              "x":350,
              "y":50,
              "value":"企业机会推送"
            },
            "type":"node_start",
            "properties":{
              "width":100,
              "height":60,
              "rx":30,
              "start":true,
              "style_fill":"#C6E2FF",
              "style_color":"#000080",
              "style_stroke":"#7EC8E3",
              "style_name":"浅天蓝",
              "code":"create"
            }
          },
          {
            "code":"leader_company_name",
            "x":0,
            "y":150,
            "name":"企业名称关键词",
            "id":"leader_company_name",
            "text":{
              "x":0,
              "y":150,
              "value":"企业名称关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_name",
            "x":700,
            "y":150,
            "name":"企业名称关键词",
            "id":"team_company_name",
            "text":{
              "x":700,
              "y":150,
              "value":"企业名称关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_industry_category",
            "x":233,
            "y":150,
            "name":"所属行业",
            "id":"leader_industry_category",
            "text":{
              "x":233,
              "y":150,
              "value":"所属行业"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_industry_category",
            "x":467,
            "y":150,
            "name":"所属行业",
            "id":"team_industry_category",
            "text":{
              "x":467,
              "y":150,
              "value":"所属行业"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_scale",
            "x":233,
            "y":250,
            "name":"企业规模",
            "id":"leader_company_scale",
            "text":{
              "x":233,
              "y":250,
              "value":"企业规模"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_scale",
            "x":467,
            "y":250,
            "name":"企业规模",
            "id":"team_company_scale",
            "text":{
              "x":467,
              "y":250,
              "value":"企业规模"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_staff_cnt",
            "x":0,
            "y":250,
            "name":"员工人数",
            "id":"leader_staff_cnt",
            "text":{
              "x":0,
              "y":250,
              "value":"员工人数"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_staff_cnt",
            "x":700,
            "y":250,
            "name":"员工人数",
            "id":"team_staff_cnt",
            "text":{
              "x":700,
              "y":250,
              "value":"员工人数"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_capital",
            "x":0,
            "y":350,
            "name":"注册资本",
            "id":"leader_company_capital",
            "text":{
              "x":0,
              "y":350,
              "value":"注册资本"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_capital",
            "x":700,
            "y":350,
            "name":"注册资本",
            "id":"team_company_capital",
            "text":{
              "x":700,
              "y":350,
              "value":"注册资本"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_brief_introduction",
            "x":233,
            "y":350,
            "name":"企业简介关键词",
            "id":"leader_company_brief_introduction",
            "text":{
              "x":233,
              "y":350,
              "value":"企业简介关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_brief_introduction",
            "x":467,
            "y":350,
            "name":"企业简介关键词",
            "id":"team_company_brief_introduction",
            "text":{
              "x":467,
              "y":350,
              "value":"企业简介关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_business_scope",
            "x":233,
            "y":450,
            "name":"经营范围关键词",
            "id":"leader_company_business_scope",
            "text":{
              "x":233,
              "y":450,
              "value":"经营范围关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_business_scope",
            "x":467,
            "y":450,
            "name":"经营范围关键词",
            "id":"team_company_business_scope",
            "text":{
              "x":467,
              "y":450,
              "value":"经营范围关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_bid",
            "x":0,
            "y":450,
            "name":"招投标关键词",
            "id":"leader_company_bid",
            "text":{
              "x":0,
              "y":450,
              "value":"招投标关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_bid",
            "x":700,
            "y":450,
            "name":"招投标关键词",
            "id":"team_company_bid",
            "text":{
              "x":700,
              "y":450,
              "value":"招投标关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_recruit",
            "x":0,
            "y":550,
            "name":"招聘关键词",
            "id":"leader_company_recruit",
            "text":{
              "x":0,
              "y":550,
              "value":"招聘关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_recruit",
            "x":700,
            "y":550,
            "name":"招聘关键词",
            "id":"team_company_recruit",
            "text":{
              "x":700,
              "y":550,
              "value":"招聘关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_tag",
            "x": 233,
            "y":550,
            "name":"企业标签",
            "id":"leader_company_tag",
            "text":{
              "x":233,
              "y":550,
              "value":"企业标签"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_tag",
            "x": 467,
            "y":550,
            "name":"企业标签",
            "id":"team_company_tag",
            "text":{
              "x":467,
              "y":550,
              "value":"企业标签"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_financing",
            "x":233,
            "y":650,
            "name":"融资历程",
            "id":"leader_company_financing",
            "text":{
              "x":233,
              "y":650,
              "value":"融资历程"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_financing",
            "x":467,
            "y":650,
            "name":"融资历程",
            "id":"team_company_financing",
            "text":{
              "x":467,
              "y":650,
              "value":"融资历程"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_patent",
            "x":0,
            "y":650,
            "name":"专利信息关键词",
            "id":"leader_company_patent",
            "text":{
              "x":0,
              "y":650,
              "value":"专利信息关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_patent",
            "x":700,
            "y":650,
            "name":"专利信息关键词",
            "id":"team_company_patent",
            "text":{
              "x":700,
              "y":650,
              "value":"专利信息关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_competitor",
            "x":0,
            "y":750,
            "name":"竞品信息关键词",
            "id":"leader_company_competitor",
            "text":{
              "x":0,
              "y":750,
              "value":"竞品信息关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_competitor",
            "x":700,
            "y":750,
            "name":"竞品信息关键词",
            "id":"team_company_competitor",
            "text":{
              "x":700,
              "y":750,
              "value":"竞品信息关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_company_business",
            "x":233,
            "y":750,
            "name":"企业业务关键词",
            "id":"leader_company_business",
            "text":{
              "x":233,
              "y":750,
              "value":"企业业务关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_company_business",
            "x":467,
            "y":750,
            "name":"企业业务关键词",
            "id":"team_company_business",
            "text":{
              "x":467,
              "y":750,
              "value":"企业业务关键词"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"leader_pool",
            "x":233,
            "y":850,
            "name":"领导池规则",
            "id":"leader_pool",
            "text":{
              "x":233,
              "y":850,
              "value":"领导池规则"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"team_pool",
            "x":467,
            "y":850,
            "name":"团队池规则",
            "id":"team_pool",
            "text":{
              "x":467,
              "y":850,
              "value":"团队池规则"
            },
            "type":"node_judge",
            "properties":{
              "rx":50,
              "ry":30,
              "style_fill":"#FFFFFF",
              "style_color":"#333333",
              "style_stroke":"#CCCCCC",
              "style_name":"经典简约",
              "width":100,
              "height":60
            }
          },
          {
            "code":"end1",
            "x":0,
            "y":850,
            "name":"领导线索池",
            "id":"end1",
            "text":{
              "x":0,
              "y":850,
              "value":"领导线索池"
            },
            "type":"node_end",
            "properties":{
              "width":100,
              "height":100,
              "end":true,
              "r":30,
              "style_fill":"#98FB98",
              "style_color":"#006400",
              "style_stroke":"#32CD32",
              "style_name":"现代绿",
              "code":"end1"
            }
          },
          {
            "code":"end2",
            "x":700,
            "y":850,
            "name":"团队线索池",
            "id":"end2",
            "text":{
              "x":700,
              "y":850,
              "value":"团队线索池"
            },
            "type":"node_end",
            "properties":{
              "end":true,
              "r":30,
              "style_fill":"#98FB98",
              "style_color":"#006400",
              "style_stroke":"#32CD32",
              "style_name":"现代绿",
              "code":"end2",
              "width":100,
              "height":100
            }
          },
        ],
        "edges":[
          {
            "pointsList":[
              {
                "x":350,
                "y":50
              },
              {
                "x":0,
                "y":50
              },
              {
                "x":0,
                "y":120
              }
            ],
            "sourceNodeId":"create",
            "targetNodeId":"leader_company_name",
            "startPoint":{
              "x":350,
              "y":50
            },
            "endPoint":{
              "x":0,
              "y":120
            },
            "id":"edge1",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":0,
                "y":150
              },
              {
                "x":183,
                "y":150
              }
            ],
            "sourceNodeId":"leader_company_name",
            "targetNodeId":"leader_industry_category",
            "startPoint":{
              "x":0,
              "y":150
            },
            "endPoint":{
              "x":183,
              "y":150
            },
            "id":"edge2",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":233,
                "y":150
              },
              {
                "x":233,
                "y":220
              }
            ],
            "sourceNodeId":"leader_industry_category",
            "targetNodeId":"leader_company_scale",
            "startPoint":{
              "x":233,
              "y":150
            },
            "endPoint":{
              "x":233,
              "y":220
            },
            "id":"edge3",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":233,
                "y":250
              },
              {
                "x":50,
                "y":250
              }
            ],
            "sourceNodeId":"leader_company_scale",
            "targetNodeId":"leader_staff_cnt",
            "startPoint":{
              "x":233,
              "y":250
            },
            "endPoint":{
              "x":50,
              "y":250
            },
            "id":"edge4",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":0,
                "y":250
              },
              {
                "x":0,
                "y":320
              }
            ],
            "sourceNodeId":"leader_staff_cnt",
            "targetNodeId":"leader_company_capital",
            "startPoint":{
              "x":0,
              "y":250
            },
            "endPoint":{
              "x":0,
              "y":320
            },
            "id":"edge5",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":0,
                "y":350
              },
              {
                "x":183,
                "y":350
              }
            ],
            "sourceNodeId":"leader_company_capital",
            "targetNodeId":"leader_company_brief_introduction",
            "startPoint":{
              "x":0,
              "y":350
            },
            "endPoint":{
              "x":183,
              "y":350
            },
            "id":"edge6",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":233,
                "y":350
              },
              {
                "x":233,
                "y":420
              }
            ],
            "sourceNodeId":"leader_company_brief_introduction",
            "targetNodeId":"leader_company_business_scope",
            "startPoint":{
              "x":233,
              "y":350
            },
            "endPoint":{
              "x":233,
              "y":420
            },
            "id":"edge7",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":233,
                "y":450
              },
              {
                "x":50,
                "y":450
              }
            ],
            "sourceNodeId":"leader_company_business_scope",
            "targetNodeId":"leader_company_bid",
            "startPoint":{
              "x":233,
              "y":450
            },
            "endPoint":{
              "x":50,
              "y":450
            },
            "id":"edge8",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":0,
                "y":450
              },
              {
                "x":0,
                "y":520
              }
            ],
            "sourceNodeId":"leader_company_bid",
            "targetNodeId":"leader_company_recruit",
            "startPoint":{
              "x":0,
              "y":450
            },
            "endPoint":{
              "x":0,
              "y":520
            },
            "id":"edge9",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":0,
                "y":550
              },
              {
                "x":183,
                "y":550
              }
            ],
            "sourceNodeId":"leader_company_recruit",
            "targetNodeId":"leader_company_tag",
            "startPoint":{
              "x":0,
              "y":550
            },
            "endPoint":{
              "x":183,
              "y":550
            },
            "id":"edge10",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":233,
                "y":550
              },
              {
                "x":233,
                "y":620
              }
            ],
            "sourceNodeId":"leader_company_tag",
            "targetNodeId":"leader_company_financing",
            "startPoint":{
              "x":233,
              "y":550
            },
            "endPoint":{
              "x":233,
              "y":620
            },
            "id":"edge11",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":233,
                "y":650
              },
              {
                "x":50,
                "y":650
              }
            ],
            "sourceNodeId":"leader_company_financing",
            "targetNodeId":"leader_company_patent",
            "startPoint":{
              "x":233,
              "y":650
            },
            "endPoint":{
              "x":50,
              "y":650
            },
            "id":"edge12",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":0,
                "y":650
              },
              {
                "x":0,
                "y":720
              }
            ],
            "sourceNodeId":"leader_company_patent",
            "targetNodeId":"leader_company_competitor",
            "startPoint":{
              "x":0,
              "y":650
            },
            "endPoint":{
              "x":0,
              "y":720
            },
            "id":"edge13",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":0,
                "y":750
              },
              {
                "x":183,
                "y":750
              }
            ],
            "sourceNodeId":"leader_company_competitor",
            "targetNodeId":"leader_company_business",
            "startPoint":{
              "x":0,
              "y":750
            },
            "endPoint":{
              "x":183,
              "y":750
            },
            "id":"edge14",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":233,
                "y":750
              },
              {
                "x":233,
                "y":820
              }
            ],
            "sourceNodeId":"leader_company_business",
            "targetNodeId":"leader_pool",
            "startPoint":{
              "x":233,
              "y":750
            },
            "endPoint":{
              "x":233,
              "y":820
            },
            "id":"edge15",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":233,
                "y":850
              },
              {
                "x":30,
                "y":850
              }
            ],
            "sourceNodeId":"leader_pool",
            "targetNodeId":"end1",
            "startPoint":{
              "x":233,
              "y":850
            },
            "endPoint":{
              "x":30,
              "y":850
            },
            "id":"edge16",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":350,
                "y":50
              },
              {
                "x":700,
                "y":50
              },
              {
                "x":700,
                "y":120
              }
            ],
            "sourceNodeId":"create",
            "targetNodeId":"team_company_name",
            "startPoint":{
              "x":350,
              "y":50
            },
            "endPoint":{
              "x":700,
              "y":120
            },
            "id":"edge17",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":700,
                "y":150
              },
              {
                "x":517,
                "y":150
              }
            ],
            "sourceNodeId":"team_company_name",
            "targetNodeId":"team_industry_category",
            "startPoint":{
              "x":700,
              "y":150
            },
            "endPoint":{
              "x":517,
              "y":150
            },
            "id":"edge18",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":467,
                "y":150
              },
              {
                "x":467,
                "y":220
              }
            ],
            "sourceNodeId":"team_industry_category",
            "targetNodeId":"team_company_scale",
            "startPoint":{
              "x":467,
              "y":150
            },
            "endPoint":{
              "x":467,
              "y":220
            },
            "id":"edge19",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":467,
                "y":250
              },
              {
                "x":650,
                "y":250
              }
            ],
            "sourceNodeId":"team_company_scale",
            "targetNodeId":"team_staff_cnt",
            "startPoint":{
              "x":467,
              "y":250
            },
            "endPoint":{
              "x":650,
              "y":250
            },
            "id":"edge20",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":700,
                "y":250
              },
              {
                "x":700,
                "y":320
              }
            ],
            "sourceNodeId":"team_staff_cnt",
            "targetNodeId":"team_company_capital",
            "startPoint":{
              "x":700,
              "y":250
            },
            "endPoint":{
              "x":700,
              "y":320
            },
            "id":"edge21",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":700,
                "y":350
              },
              {
                "x":517,
                "y":350
              }
            ],
            "sourceNodeId":"team_company_capital",
            "targetNodeId":"team_company_brief_introduction",
            "startPoint":{
              "x":700,
              "y":350
            },
            "endPoint":{
              "x":517,
              "y":350
            },
            "id":"edg22",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":467,
                "y":350
              },
              {
                "x":467,
                "y":420
              }
            ],
            "sourceNodeId":"team_company_brief_introduction",
            "targetNodeId":"team_company_business_scope",
            "startPoint":{
              "x":467,
              "y":350
            },
            "endPoint":{
              "x":467,
              "y":420
            },
            "id":"edge23",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":467,
                "y":450
              },
              {
                "x":650,
                "y":450
              }
            ],
            "sourceNodeId":"team_company_business_scope",
            "targetNodeId":"team_company_bid",
            "startPoint":{
              "x":467,
              "y":450
            },
            "endPoint":{
              "x":650,
              "y":450
            },
            "id":"edge24",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":700,
                "y":450
              },
              {
                "x":700,
                "y":520
              }
            ],
            "sourceNodeId":"team_company_bid",
            "targetNodeId":"team_company_recruit",
            "startPoint":{
              "x":700,
              "y":450
            },
            "endPoint":{
              "x":700,
              "y":520
            },
            "id":"edge25",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":700,
                "y":550
              },
              {
                "x":517,
                "y":550
              }
            ],
            "sourceNodeId":"team_company_recruit",
            "targetNodeId":"team_company_tag",
            "startPoint":{
              "x":700,
              "y":550
            },
            "endPoint":{
              "x":517,
              "y":550
            },
            "id":"edge26",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":467,
                "y":550
              },
              {
                "x":467,
                "y":620
              }
            ],
            "sourceNodeId":"team_company_tag",
            "targetNodeId":"team_company_financing",
            "startPoint":{
              "x":467,
              "y":550
            },
            "endPoint":{
              "x":467,
              "y":620
            },
            "id":"edge27",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":467,
                "y":650
              },
              {
                "x":650,
                "y":650
              }
            ],
            "sourceNodeId":"team_company_financing",
            "targetNodeId":"team_company_patent",
            "startPoint":{
              "x":467,
              "y":650
            },
            "endPoint":{
              "x":650,
              "y":650
            },
            "id":"edge28",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":700,
                "y":650
              },
              {
                "x":700,
                "y":720
              }
            ],
            "sourceNodeId":"team_company_patent",
            "targetNodeId":"team_company_competitor",
            "startPoint":{
              "x":700,
              "y":650
            },
            "endPoint":{
              "x":700,
              "y":720
            },
            "id":"edge29",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":700,
                "y":750
              },
              {
                "x":517,
                "y":750
              }
            ],
            "sourceNodeId":"team_company_competitor",
            "targetNodeId":"team_company_business",
            "startPoint":{
              "x":700,
              "y":750
            },
            "endPoint":{
              "x":517,
              "y":750
            },
            "id":"edge30",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":467,
                "y":750
              },
              {
                "x":467,
                "y":820
              }
            ],
            "sourceNodeId":"team_company_business",
            "targetNodeId":"team_pool",
            "startPoint":{
              "x":467,
              "y":750
            },
            "endPoint":{
              "x":467,
              "y":820
            },
            "id":"edge31",
            "type":"prc-polyline"
          },
          {
            "pointsList":[
              {
                "x":467,
                "y":850
              },
              {
                "x":670,
                "y":850
              }
            ],
            "sourceNodeId":"team_pool",
            "targetNodeId":"end2",
            "startPoint":{
              "x":467,
              "y":850
            },
            "endPoint":{
              "x":670,
              "y":850
            },
            "id":"edge32",
            "type":"prc-polyline"
          },
        ],
      },
      lf: null
    }
  },
  created() {
  },
  mounted() {
    const div = document.querySelector('.page');
    this.canvasWidth = div.clientWidth-1000;
    this.canvasHeight = div.clientHeight-6;

    this.init()
    this.render(this.content)
  },
  methods:{
    init() {
      if (!this.lf) {
        this.lf = new LogicFlow({
          container: this.$refs.container,
          height:this.canvasHeight,
          width:this.canvasWidth,
          outline: true,
          isSilentMode: true,
          plugins: [Control, MiniMap],
          pluginsOptions: {
            miniMap: {
              width: 120,
              height: 150,
              isShowCloseIcon: true,
              topPosition: 70,
              rightPosition: 15
            }
          }
        });
        this.lf.register(NodeStart)
        this.lf.register(NodeNormal)
        this.lf.register(NodeJudge)
        this.lf.register(NodeEnd)
        this.lf.register(PrcPolyline)
        let control = this.lf.extension.control || {};
        control.removeItem('undo')
        control.removeItem('redo')
        control.removeItem('reset')
        control.addItem({
          key: 'original-size',
          iconClass: "lf-control-original-size",
          text: '原始尺寸',
          onClick: () => {
            this.lf.resetZoom()
          },
        })
        control.addItem({
          key: 'fit-view',
          iconClass: "lf-control-fit",
          text: '自适应',
          onClick: () => {
            this.lf.fitView()
          },
        })
        control.addItem({
          key: 'center-view',
          iconClass: "lf-control-align-center",
          text: '居中显示',
          onClick: () => {
            this.lf.translateCenter()
          },
        })
        control.addItem({
          key: 'mini-map',
          iconClass: "lf-control-custom-minimap",
          text: '小地图',
          onClick: () => {
            if (this.lf.extension.miniMap.isShow) {
              this.lf.extension.miniMap.hide()
            } else {
              this.lf.extension.miniMap.show()
            }
          },
        })

        this.lf.on("node:click", data => {
          let node = data.data
          this.$emit('node-click', node)
          if (!(node.type === 'node_start' || node.type === 'node_end')){
            this.ruleId = node.id
          }
        })
      }
    },
    render(data) {
      this.lf.render(data);
      setTimeout(() => {
        this.lf.fitView();
        this.lf.translateCenter()
      }, 200)
    }
  }
}
</script>

<style lang="less">
.lf-control-custom-minimap {
  background-image: url("data:image/png;base64,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");
}
</style>

<style scoped>
.right-form{
  width: 1000px;
  padding: 20px;
  overflow-y: auto;
}
.page{
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
}
.container {
  background-color: #eaeaea;
  border-right: grey 1px solid;
}

.container :deep(.lf-control-item) {
  padding: 5px 8px;
}

.container :deep(.lf-control-item i) {
  height: 18px;
  width: 18px;
}

.container :deep(.lf-control-item .lf-control-text) {
  font-size: 10px;
}
</style>